import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';

import { DeviceDetectorModule } from 'ngx-device-detector';

import { CommonService, CustomTranslateHttpLoader, GastCommonNgModule, PortalHttpErrorInterceptor, selectEnvironmentFile, TranslationService } from 'gast-common-ng';
import { GastOnsetNgModule } from 'gast-onset-ng';

import { AppComponent } from './app.component';
import { IdasOnsetComponent } from './idas-onset/idas-onset.component';
import { HomeComponent } from './home/home.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { AuthGuard } from '../shared/services/common/auth-guard.service';
import { AuthService, GastPortalNgModule } from 'gast-portal-ng';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { UrlService } from '../shared/services/common/url.service';
import { FormsModule } from '@angular/forms';
import { DemoComponent } from './demo/demo.component';
import { ConnectorComponent } from './connector/connector.component';
import { ConnectorOnsetComponent } from './connector-onset/connector-onset.component';
import { ConnectorService } from 'src/shared/services/idas/connector.service';
import { ConnectorAuthService } from 'src/shared/services/common/connector-auth.service';
import { IdasService } from 'src/shared/services/idas/idas.service';
import { IdasAuthGuard } from 'src/shared/services/common/idas-auth-guard.service';
import { OnsetStudyComponent } from './onset-study/onset-study.component';
import { OnsetStudyHomeComponent } from './onset-study-home/onset-study-home.component';
import { GerInfoComponent } from './ger-info/ger-info.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  const urls: Array<string> = [
    './common-assets/i18n/',
    './portal-assets/i18n/',
    './onset-assets/i18n/',
    './assets/i18n/'
  ];
  return new CustomTranslateHttpLoader(httpClient, urls, '.json');
}

export function TranslationServiceFactory(translateService: TranslateService, commonService: CommonService) {
  return new TranslationService(translateService, commonService);
}

@NgModule({
  declarations: [
    AppComponent,
    IdasOnsetComponent,
    HomeComponent,
    DemoComponent,
    ConnectorComponent,
    ConnectorOnsetComponent,
    ConnectorComponent,
    OnsetStudyComponent,
    OnsetStudyHomeComponent,
    GerInfoComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    GastCommonNgModule.forRoot(),
    GastOnsetNgModule.forRoot({
      provide: TranslationService,
      useFactory: TranslationServiceFactory,
      deps: [TranslateService]
    }),
    DeviceDetectorModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    GastPortalNgModule.forRoot({
      provide: TranslationService,
      useFactory: TranslationServiceFactory,
      deps: [TranslateService, CommonService]
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    {
      provide: 'env',
      useValue: { callback: selectEnvironmentFile, value: environment.envName }
    },
    ConnectorAuthService,
    ConnectorService,
    IdasService,
    IdasAuthGuard,
    DatePipe,
    AuthGuard,
    AuthService,
    CommonService,
    UrlService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
